<template>
  <div class="d-flex flex-wrap">
    <div v-for="(item, i) in arr" :key="i">
      <v-hover v-slot="{ hover }">
        <v-card
          class="ma-1"
          :elevation="hover ? 16 : 2"
          :class="{ 'on-hover': hover }"
          width="240"
          style="min-height: 250px"
        >
          <lottie-auto-player :url="item.imgUrl"></lottie-auto-player>
        </v-card>
      </v-hover>
    </div>
  </div>
</template>

<script>
import LottieAutoPlayer from "./LottieAutoPlayer.vue";

const arr = [
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707293395298.json",
  },
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707089586279.json",
  },
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707089690255.json",
  },
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707089885173.json",
  },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707090111246.json",
  // },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Polite Chicky.json",
  // },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Aniki Hamster.json",
  // },
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707292771651.json",
  },
  {
    imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707292860613.json",
  },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707293074220.json",
  // },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707293086302.json",
  // },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707293145356.json",
  // },
  // {
  //   imgUrl: "public/cdn/v1/assets/effects/lottie/Animation - 1707293266092.json",
  // },
];

export default {
  components: {
    LottieAutoPlayer,
  },
  data() {
    return {
      arr: arr.map((item, i) => {
        return {
          id: i,
          imgUrl: item.imgUrl.replace("public", ""),
        };
      }),
    };
  },
};
</script>

<style></style>
